module.exports = __webpack_public_path__ + "img/home_mianfei.8b6bbfb6.png";